/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import {
  resetBackRoute,
  setBackRoute,
  resetVesselsState,
  setVessels,
  setSelectedVessel,
} from '.';
import { Vessel } from './models';

interface VesselsState {
  backRoute?: string;
  vessels: Vessel[];
  selectedVesselId?: Vessel['id'];
}

const initialState: VesselsState = {
  backRoute: undefined,
  vessels: [],
  selectedVesselId: undefined,
};

// eslint-disable-next-line import/prefer-default-export
export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(setBackRoute, (state, { payload }) => {
    state.backRoute = payload;
  });
  builder.addCase(resetBackRoute, (state) => {
    state.backRoute = initialState.backRoute;
  });

  builder.addCase(resetVesselsState, (state) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state = initialState;
  });

  builder.addCase(setVessels, (state, action) => {
    state.vessels = action.payload;
  });

  builder.addCase(setSelectedVessel, (state, action) => {
    state.selectedVesselId = action.payload;
  });
});
